<template>
<div>
	<!-- <div id="" style="width:750px;height:600px;box-shadow: 0 0 20px #ccc;z-index: 99999;" > -->
		<!-- <iframe id="myFrame" scrolling="no" frameborder="0" :src="urlImg2"  v-if="isShowIframe" width="100%" style=" width: 100%; height:130vw;position: fixed;bottom: 0;right:0;z-index: 99999;"></iframe> -->
	<!-- </div> -->
	<div class="openService" id="openService">
	    <img :src="urlImg" />
	</div>
    <div class="fixedBtn">
        <!-- <div class="CnorEn" @click="CNorENClick()">
            <img v-show="$store.state.i18n" src="@/images/english/i18n_en.png" />
            <img v-show="!$store.state.i18n" src="@/images/english/i18n_zh.png" />
        </div> -->
        <div class="service" @click="backShow = !backShow">
            <img src="@/images/home/1-29.png"/>
        </div>
        <div class="backTop" @click="backTop()">
            <img src="@/images/home/1-28.png"/>
        </div>
        <div class="backShow" v-show="backShow">
           <div class="title">{{$store.state.i18n?componentsLang.phone.chinese.backTop.tel:componentsLang.phone.english.backTop.tel}}</div>
            <div>4008040080</div>
            <div class="title">{{$store.state.i18n?componentsLang.phone.chinese.backTop.email:componentsLang.phone.english.backTop.email}}</div>
            <div>jdh@jdh.com.cn</div>
            <div class="title">{{$store.state.i18n?componentsLang.phone.chinese.backTop.qq:componentsLang.phone.english.backTop.qq}}</div>
            <div>800178080</div>
        </div>
    </div>
</div>
    
</template>



<script>
import { sha256 } from 'js-sha256'
export default {
    data(){
        return {
            backShow: false,
			urlImg:'../../static/service.png',
			// urlImg2:'',
			isShowIframe:'',
			lang:'zh-cn'
        }
    },
	computed:{
		isChang(){
			return this.$store.state.i18n
		}
	},
	watch:{
		isChang: {
		　　handler(newName, oldName) {
			  if(newName){
				    this.lang = "zh-cn"
				    let src = 'service.png'
					this.urlImg = require("../../static/"+src)
			  }else{
				    this.lang = "en-us"
				    let src = 'serviceEn.png'
					this.urlImg = require("../../static/"+src)
			  }
		　　},
		　　immediate: true
		}
	},
    activated(){
		if(this.$store.state.vals == 0){
			this.$nextTick(()=>{
				let times = new Date().getTime();
				(function(a, h, c, b, f, g) {
					a["UdeskApiObject"] = f;
					a[f] = a[f] || function() {
						(a[f].d = a[f].d || []).push(arguments)
					};
					g = h.createElement(c);
					g.async = 1;
					g.charset = "utf-8";
					g.src = b;
					c = h.getElementsByTagName(c)[0];
					c.parentNode.insertBefore(g, c)
				})(window, document, "script", "https://assets-cli.s4.udesk.cn/im_client/js/udeskApi.js", "ud");
				ud({
					"code": "1a0gik6d",
					"link": "https://1537573.s4.udesk.cn/im_client/?web_plugin_id=34714",
					"targetSelector": "#openService",
					"language": this.lang, //语言-英文
					"mobile": { //为响应式布局，提供pc、mobile自定制
						"mode": "blank",
						"color": "#307AE8",
						"pos_flag": "crb",
						"onlineText": "联系客服，在线咨询",
						"offlineText": "客服下班，请留言"
					},
					"customer": {
						"nonce": "9ca6fff5a509fb887ac72cf5c92010e7",
						"timestamp": times,
						"encryption_algorithm": "SHA256"
					}
				});
			})
			
			
		}else{
			this.$nextTick(()=>{
				let times = new Date().getTime();
				let manualInit = false
				if(this.lang = "en-us"){
					manualInit = true
				}
				(function(a, h, c, b, f, g) {
					a["UdeskApiObject"] = f;
					a[f] = a[f] || function() {
						(a[f].d = a[f].d || []).push(arguments)
					};
					g = h.createElement(c);
					g.async = 1;
					g.charset = "utf-8";
					g.src = b;
					c = h.getElementsByTagName(c)[0];
					c.parentNode.insertBefore(g, c)
				})(window, document, "script", "https://assets-cli.s4.udesk.cn/im_client/js/udeskApi.js", "ud");
				ud({
					"code": "1a0gik6d",
					"link": "https://1537573.s4.udesk.cn/im_client/?web_plugin_id=34714",
					"targetSelector": "#openService",
					"language": this.lang, //语言-英文
					"manualInit":manualInit,
					"mobile": { //为响应式布局，提供pc、mobile自定制
						"mode": "blank",
						"color": "#307AE8",
						"pos_flag": "crb",
						"onlineText": "联系客服，在线咨询",
						"offlineText": "客服下班，请留言"
					},
					"customer": {
						"nonce": "9ca6fff5a509fb887ac72cf5c92010e7",
						"timestamp": times,
						"encryption_algorithm": "SHA256"
					}
				});
				if(manualInit){
					ud('init');
				}
				
			})
		}
    },
    created(){
    },
    methods:{
        // 返回顶部
        backTop(){
            let top = document.documentElement.scrollTop || document.body.scrollTop;
            // 实现滚动效果 
            const timeTop = setInterval(() => {
                document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
                if (top <= 0) {
                clearInterval(timeTop);
                }
            }, 10);
        },
        // 中英文切换
        CNorENClick(){
            this.$emit('loadingShowClick',true);
            setTimeout(()=>{
                this.$store.commit('setI18n');
                this.$router.go(0);
            },1500)
            
        }
    }
}
</script>


<style scoped>
*{
    margin:0;
    padding:0;
    box-sizing: border-box;
}


.backShow{
    width: 47.626vw;
    height: 61.25vw;
    background-image: url('../../images/home/1-48.png');
    background-size: 100% 100%;
    position: absolute;
    top: -22.916vw;
    left: -21.834vw;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding-right: 2.083vw;
    letter-spacing: 0.208vw;
    transform: scale(0.5) translateX(-50%);
}
.backShow>div:nth-child(even){
    color: #c31618;
    margin: 0.817vw 0 5vw;
    font-weight: bolder;
}
.backShow>div{
    font-size: 3.75vw;
}
.backShow .title{
    font-size:4vw;
    font-weight:bold;
}





/* 联系客服 or  返回顶部 */
.fixedBtn{
    transform: scale(0.9);
    /* width:9vw;height:24vw; */
    width:9vw;height:18vw;
    position: fixed;
    right:5.208vw;
    top:115.25vw;
    z-index:999;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 0.052vw solid #859199;
    cursor: pointer;
}
.fixedBtn .CnorEn{
    width:100%;height:50%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    background-color: white;
}
.fixedBtn .service{
    width:100%;height:50%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    background-color:#c6151d;
}
.fixedBtn .backTop{
    width:100%;height:50%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    background-color: white;
}
.fixedBtn .CnorEn img{
    width:5.99vw;height:5.6vw;
    transition: .3s;
}
.fixedBtn .service img{
    width:5.99vw;height:5.6vw;
    transition: .3s;
}
.fixedBtn .backTop img{
    width:5.99vw;height:5.6vw;
    transition: .3s;
}
.openService{
	width: 9vw;
	position: fixed;
	right:4.6vw;
	top:107vw;
	z-index:999;
}
.openService img{
	width: 7.9vw;
	height: 8vw;
}
</style>


// WEBPACK FOOTER //
// src/components/mobileBackTop/index.vue